// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"21":"assets/themes/bkw/css/app.be","793":"assets/themes/bkw/css/app.fe","848":"assets/themes/bkw/css/mail/default"}[chunkId] + ".css";
};